var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field",class:{ hasError: _vm.error }},[_c('input',{staticClass:"input",attrs:{"id":_vm.id,"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.handleChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }